import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateGroupPermissionActions } from 'store/ducks/settings/group-permissions';

export function* createGroupPermissionRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/group-permission`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateGroupPermissionActions.success(data));
    notify('success', 'Permissão do Perfil adicionada com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateGroupPermissionActions.failure(errorMessage));
  }
}
